import { css } from "@emotion/react";
import { Button } from "../../Button";
import { CSVImportUIColumns } from "../CSVImportUI";
import { CSVImportUITable } from "../CSVImportUITable";
import { ScreenLayout } from "../ScreenLayout";
import { getTemplateFilename } from "../getTemplateFilename";
import { ScreenProps } from "./types";

export interface CompleteScreenProps<Row> extends ScreenProps {
  data: Row[];
  headers: string[];
  errors: ([string, string][] | undefined)[];
  csvPrefix?: string;
  onDownloadCSV: (args: { data: Row[]; filename: string }) => void;
  columns?: CSVImportUIColumns;
  title?: string;
}

export const CompleteScreen = <Row extends Record<string, string>>({
  data,
  headers,
  errors,
  csvPrefix,
  onDownloadCSV,
  columns,
  title = "アップロードが完了しました",
}: CompleteScreenProps<Row>) => {
  const handleDownloadErrorCSV = () => {
    const errorRows = errors
      .map((error, index) => {
        if (error === undefined || error.length === 0) {
          return null;
        }
        const row = data[index];
        return row;
      })
      .filter((row): row is Row => row !== null);

    onDownloadCSV({
      data: errorRows,
      filename: getTemplateFilename("import-error", csvPrefix),
    });
  };

  const handleDownloadCSV = () => {
    onDownloadCSV({
      data,
      filename: getTemplateFilename("imported", csvPrefix),
    });
  };
  return (
    <ScreenLayout title={title}>
      <div
        css={css`
          display: grid;
          gap: 16px;
        `}
      >
        <CSVImportUITable
          columns={columns}
          rows={data}
          errors={errors}
          headers={headers}
        />

        <div
          css={css`
            display: flex;
            gap: 8px;
            align-items: center;
            justify-content: flex-end;
          `}
        >
          {errors.some((error) => error !== undefined) && (
            <Button
              variant="filled"
              color="primary"
              onClick={handleDownloadErrorCSV}
            >
              エラーになった行のみCSVでダウンロード
            </Button>
          )}
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDownloadCSV}
          >
            処理したデータをCSVでダウンロード
          </Button>
        </div>
      </div>
    </ScreenLayout>
  );
};
